import { DashboardCard } from '@/components/ui/dashboard-card.tsx';

export const AutoTraderStatus = () => {
  const lastDecision = 'SELL 200kWh @ €119.50';
  const time = '14:32';
  const reason = 'Price > €118 threshold';
  const profitToday = '€45.20';
  return (
    <DashboardCard className="text-base">
      <div className="mb-4 text-base font-semibold">Auto-Trader Status</div>
      <div className="flex flex-col gap-2.5">
        <div>
          <span className="mb-1 block text-zinc-500">Last Decision</span>
          <div className="font-semibold text-green-500">{lastDecision}</div>
        </div>
        <div>
          <span className="text-zinc-500">Time: </span>
          <span>{time}</span>
        </div>
        <div>
          <span className="mb-1 block text-zinc-500">Reason</span>
          <div>{reason}</div>
        </div>
        <div className="mt-2 border-t border-zinc-200 pt-3">
          <span className="text-zinc-500">Profit Today: </span>
          <span className="font-semibold text-green-500">{profitToday}</span>
        </div>
      </div>
    </DashboardCard>
  );
};

export default AutoTraderStatus;
